import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  if (!cfg.url) return cfg;
  cfg.headers = cfg.headers || {};
  // Admin endpoints
  if (cfg.url.startsWith("/admin")) {
    const token = localStorage.getItem("besson_admin_token");
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
  }
  // Entrepreneur portal endpoints
  else if (cfg.url.startsWith("/portal")) {
    const token = localStorage.getItem("besson_portal_token");
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

export default api;
